<template>
  <modal-card :title="title" cancel-text="Close">
    <b-table
      :data="tasks"
      :mobile-cards="true"
      striped
      class="has-vertical-align-middle"
    >
      <template slot-scope="props">
        <b-table-column label="Status" width="100">
          <status-label
            :status="$store.getters['tasks/task/status'](props.row.status)"
          />
        </b-table-column>

        <b-table-column label="Task">
          <router-link
            :to="{ path: `/tasks/magic/${props.row._id}` }"
            class="has-text-dark"
            @click.native="$emit('close')"
          >
            <u>{{ props.row.reference }}</u>
          </router-link>
          <p class="is-size-7 has-text-grey has-white-space-nowrap">
            {{ props.row.taskType }} ·
            {{ $moment(props.row.dateCreated.toDate()).format("D MMM YYYY") }}
          </p>
        </b-table-column>

        <b-table-column label="Raised by">
          <router-link
            v-if="getAuthor(props.row)"
            :to="{ path: `/admin/users/${props.row.authorId}` }"
            class="has-text-dark"
            @click.native="$emit('close')"
          >
            <u>{{ getAuthor(props.row) }}</u>
          </router-link>
          <span v-else class="has-text-grey">–</span>
        </b-table-column>

        <b-table-column label="First response">
          <span v-if="getFirstResponseTime(props.row)">
            {{ formatDuration(getFirstResponseTime(props.row)) }}
          </span>
          <span v-else class="has-text-grey">–</span>
        </b-table-column>

        <b-table-column label="Rating" width="110">
          <span
            v-if="props.row.rating > 0"
            class="has-white-space-nowrap"
            :title="`${props.row.rating} / 5`"
          >
            <b-icon
              v-for="index in 5"
              :key="index"
              :pack="index <= props.row.rating ? 'fas' : 'far'"
              :type="index <= props.row.rating ? 'is-success' : 'is-grey'"
              icon="star"
              size="is-small"
            />
          </span>
          <span v-else class="has-text-grey">–</span>
        </b-table-column>

        <b-table-column v-if="showFeedback" label="Feedback">
          <span v-if="props.row.feedback" class="has-white-space-pre-line">{{
            props.row.feedback
          }}</span>
          <span v-else class="has-text-grey">No comment left</span>
        </b-table-column>
      </template>
    </b-table>
  </modal-card>
</template>

<script>
import { formatDuration, getFirstResponseTime } from "@src/data/task";

export default {
  name: "AgentTasksModal",
  props: {
    // Tasks as loaded by `AgentTaskStats`, in the order to list them
    tasks: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    showFeedback: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatDuration,
    getFirstResponseTime,
    getAuthor(task) {
      const author = this.$_.get(task, `participantsData.${task.authorId}`);
      return author ? author.name || author.email : null;
    }
  }
};
</script>
